import React from "react";

export default function HowItWorks() {
    const steps = [
        {
            no: "01",
            title: "Search What are you looking for",
            desc: "You can type like restaurant, hotels",
        },
        {
            no: "02",
            title: "Find the suitable business/person",
            desc: "Get the list of searched business/person",
        },
        {
            no: "03",
            title: "Get their details",
            desc: "You can get there contact details",
        },
    ];

    return (
        <div className="container text-center my-5" style={{ maxWidth: "1000px" }}>

            <h4 className="fw-bold mb-5" style={{ fontSize: "22px" }}>
                How it <span className="text-primary">works?</span>
            </h4>

            <div className="row justify-content-center g-4">
                {steps.map((step, i) => (
                    <div key={i} className="col-12 col-md-4 d-flex justify-content-center">

                        <div
                            style={{
                                width: "260px",
                                padding: "5px 5px",
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "16px",
                            }}
                        >

                            {/* Number Box */}
                            <div
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "10px",
                                    background: "#F7F8FC",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    color: "#000",
                                    boxShadow: "0 3px 12px rgba(0,0,0,0.1)",
                                }}
                            >
                                {step.no}
                            </div>

                            {/* Text Section */}
                            <div style={{ textAlign: "left" }}>
                                <div
                                    className="fw-semibold"
                                    style={{
                                        fontSize: "15px",
                                        color: "#111",
                                        marginBottom: "4px",
                                        lineHeight: "20px"
                                    }}
                                >
                                    {step.title}
                                </div>

                                <div
                                    style={{
                                        fontSize: "12px",
                                        color: "#8B97A5",
                                        lineHeight: "16px",
                                    }}
                                >
                                    {step.desc}
                                </div>
                            </div>

                        </div>

                    </div>
                ))}
            </div>

        </div>
    );
}
